module.exports = __webpack_public_path__ + "img/confirm.28c76405.gif";